<template lang="html">
  <div class="">
    <v-window
      :value="window"
      touchless
      color="transparent"
    >
      <v-window-item key="0">
        <si-container>
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="view"
                      :items="viewOptions"
                      label="View"
                      outlined
                      single-line
                      hide-details
                      prepend-inner-icon="filter_list"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="sortKey"
                      :items="sortOptions"
                      label="Sorty by"
                      outlined
                      single-line
                      hide-details
                      prepend-inner-icon="sort"
                      :append-outer-icon="sortAscending ? 'arrow_downward': 'arrow_upward'"
                      @click:append-outer="sortAscending = !sortAscending"
                    />
                  </v-flex>
                </v-layout>
              </v-card-title>

              <v-list two-line>
                <div
                  v-for="(request, i) in requests"
                  :key="request.id"
                >
                  <v-list-item
                    :to="`/assistance/${request.id}`"
                    :style="unSeenMarker(request.timestamp)"
                  >
                    <v-list-item-avatar
                      :color="request.color"
                      class="white--text ml-n1"
                    >
                      {{ _initials(request.client) }}
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ request.client }}</v-list-item-title>
                      <v-list-item-subtitle>{{ request.title }}</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="request.client_reference">
                        Client reference: {{ request.client_reference }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-subtitle class="captionxx">
                        {{ _formatDateTime(request.timestamp) }}
                      </v-list-item-subtitle>
                    </v-list-item-action>
                    <v-list-item-action v-if="request.status !== 'closed'">
                      <v-flex
                        text-right
                        pa-0
                      >
                        {{ request.timeLeftText }}
                        <v-progress-linear
                          :value="request.elapsedPercent"
                          :color="_elapsedColor(request.elapsedPercent)"
                          class="ma-0"
                          style="width:60px"
                        />
                      </v-flex>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="i < (requests || []).length -1"
                    inset
                  />
                </div>
                <template v-if="(requests || []).length === 0 && !_loader ">
                  <v-list-item>
                    <v-list-item-title class="grey--text font-italic">
                      No reqeusts to show...
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>

      <v-window-item key="1">
        <AssistanceView :requests-index="requestsObj" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { sortBy, maxBy } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import moment from 'moment'
import helpers from '@/mixins/helpers'
import durations from '@/mixins/durations'
import binder from '@/mixins/binder'
import seen from '@/mixins/seen'
import colors from 'vuetify/lib/util/colors'

export default {
  mixins: [ helpers, durations, binder, seen ],
  data () {
    return {
      seenLast: null,
      clientColors: {},
      requests: [],
      requestsObj: {},
      view: 'open',
      sortKey: 'timestamp',
      sortAscending: false,
      viewOptions: [
        { text: 'Open', value: 'open' },
        { text: 'Closed', value: 'closed' }
      ],
      sortOptions: [
        { text: 'Date submitted', value: 'timestamp' },
        { text: 'Due', value: 'timeLeft' },
        { text: 'Client Name', value: 'client' },
        { text: 'Calculation Type', value: 'calculation' },
        { text: 'Assistance Type', value: 'assistanceDuration' }

      ]
    }
  },
  computed: {
    ...mapGetters(['_loader', '_badgeTotals', '_user']),
    window () {
      return this.$route.params.sub ? 1 : 0
    }
  },
  watch: {
    view () {
      this.bindRequests()
    },
    sortAscending () {
      this.sortResults()
    },
    sortKey () {
      this.sortResults()
    },
    requests (v, ov) {
      console.log(v);
      if ((ov || []).length === 0 && (v || []).length > 0) {
        let timestamp = maxBy(v, 'timestamp').timestamp
        this._seenUpdate('assistance', timestamp)
      }
    },
    _badgeTotals () {
      if (!this.$route.params.sub) this._seenUpdate('assistance')
    }
  },
  beforeMount () {
    this.seenLast = this._seenLast('assistance')
    this._seenWatch('assistance', !this.$route.params.sub)
    this.bindRequests()
    this.$store.commit('set_appBarTitle', { title: 'Assistance', icon: 'support_agent' })
  },
  mounted () {
    this._seenUpdate('assistance')
  },
  methods: {
    bindRequests () {
      const callback = (v) => {
        this.requestsObj = v
        this.requests = this.buildList(v)
        this.sortResults()
      }
      this.$bindRtdb(
        "requests", 
        rtdb.ref(`assistance/_index`).orderByChild('status').equalTo(this.view), 
        { callback, loader: true} 
      )
    },
    buildList (requests) {
      return Object
        .entries(requests)
        .reduce((requests, [id, r]) => {
          let clientHash = window.btoa(r.email || r.client)
          if (!this.clientColors[clientHash]) {
            this.clientColors[clientHash] = this._randomMaterialColor()
          }
          return [
            ...requests,
            {
              ...r,
              id,
              color: this.clientColors[clientHash],
              initials: this._initials(r.client),
              assistanceDuration: Number(r.assistanceDuration),
              timeLeft: this._timeLeft(r.timestamp, (r.assistanceDuration || r.duration)),
              timeLeftText: this._timeLeftText(r.timestamp, (r.assistanceDuration || r.duration)),
              elapsedPercent: this._elapsedPercent(r.timestamp, (r.assistanceDuration || r.duration)),
            }
          ]
        },[])
        .sort((a,b) => a.timeLeft > b.timeLeft ? 1 : ((b.timeLeft > a.timeLeft) ? -1 : 0))
    },
    sortResults () {
      if (this.sortAscending) {
        this.requests = sortBy(this.requests, [this.sortKey, 'client'])
      } else {
        this.requests = sortBy(this.requests, [this.sortKey, 'client']).reverse()
      }
    },

    unSeenMarker (ts) {
      let color = colors.blue.base
      if (moment(ts).isSameOrBefore(this.seenLast, 'second')) color = 'transparent'
      return `border-left: 4px ${color} solid;`
    }
  }
}
</script>
<style lang="css" scoped>

</style>
